import React from 'react';
import { useHistory } from "react-router-dom";
import { AppBar, Toolbar, IconButton} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import {PermIdentity, ExitToApp} from '@material-ui/icons';

import CookieStor from '../CookieStor'
import Menu from './Menu'

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#FAFAFA',
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.24), 0px 0px 2px rgba(0, 0, 0, 0.12)',
    borderRadius: "2px",
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },

  profileButton: {
    marginLeft: theme.spacing(2),
  },
  
  buttonContainer: {
    flexGrow: 1,
    textAlign: 'right',
  },
}));


function Header(props) {
  
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const history = useHistory();
  
  const logout = () => {
    CookieStor.setAccessToken('');
    CookieStor.setRefreshToken('');
    history.push('/');
  };
  
  return (
      <div className={classes.root}>
      <AppBar position="static" className={classes.root}  color="primary">
        <Toolbar>
          <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
            <MenuIcon style={{color: '#999999', fontSize: 32}} />
          </IconButton>
          <div className={classes.buttonContainer}>
            <IconButton
              className={classes.profileButton}
              edge="end"
              aria-label="Выйти из личного кабинета"
              aria-haspopup="true"
              color="inherit"
              onClick= {logout}
            >
              <ExitToApp style={{color: '#999999', fontSize: 32}} />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      <Menu openMenu={open} handleDrawerClose={handleDrawerClose} logout={logout}/>
    </div>
  );
}


export default Header;
